import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addBettingMarket } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import { AddBettingMarketParams } from "@/types/ApiResponses/BettingMarket";

export const useAddBettingMarket = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddBettingMarketParams) => addBettingMarket(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BettingMarketsQueryKeys.BettingMarkets] });
    },
  });
};
